export enum EFeedback {
  createFeedBack = 'feedback/createFeedback',
  submitFeedBacks = 'feedback/submitFeedbacks'
}
